import { render, staticRenderFns } from "./ProjectLedgerPagination.vue?vue&type=template&id=9515e712&scoped=true"
import script from "./ProjectLedgerPagination.vue?vue&type=script&lang=js"
export * from "./ProjectLedgerPagination.vue?vue&type=script&lang=js"
import style0 from "./ProjectLedgerPagination.vue?vue&type=style&index=0&id=9515e712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9515e712",
  null
  
)

export default component.exports